var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 1 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_124_1101025",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0.757812L9.24265 5.00046L5 9.2431L0.757355 5.00046L5 0.757812Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.2431L3.58579 10.6573L5 12.0715L6.41421 10.6573L5 9.2431ZM7.82843 3.58624L3.58579 7.82889L6.41421 10.6573L10.6569 6.41467L7.82843 3.58624ZM6.41421 7.82889L2.17157 3.58624L-0.656859 6.41467L3.58579 10.6573L6.41421 7.82889Z",
    fill: "#130F35",
    mask: "url(#path-1-inside-1_124_1101025)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownSmall);
export default __webpack_public_path__ + "static/media/ArrowDownSmall.2d30c9582a5c32cf7c81e7a0fe11ca03.svg";
export { ForwardRef as ReactComponent };